import http from "../../../request";

export default {
  // all: async (context) => {
  //   let response = await http.get("legacy", localStorage.getItem("lang"));
  //   context.commit("setLegacy", response);
  // },
  filterLegacy: async (context, payload) => {
    if (!context.state.allLegacyLoaded) {
      context.commit("noResult", false);

      let response = await http.get(
        `legacy/filter/${payload.type}/${payload.year}`,
        `${localStorage.getItem("lang")}&page=${context.state.page}`
      );
      context.commit("setLegacy", response.data);
      if (response.data.length == 0) {
        context.commit("noResult", true);
      }
      context.commit("setMeta", response.meta);
      if (context.state.meta) {
        if (context.state.meta.last_page > context.state.page) {
          context.commit("increasePage");
        } else {
          context.commit("allLegaciesLoaded", true);
        }
      }
    }
  },
  resetLegacy: (context) => {
    context.commit("reset");
  },
  resetLegacyDetails: (context) => {
    context.commit("resetLegacyDetails");
  },
  getLegacy: async (context, payload) => {
    let response = await http.get(
      `legacy/${payload}`,
      localStorage.getItem("lang")
    );
    context.commit("setLegacyDetails", response);
  },
};
